<template>
<div class="view-content">
	  <div class="view-content-info">
		<div class="user-login">
		  	<div class="user-login-title"><a href="/">首页</a> / <span>优惠券</span></div>
			<div class="center flex-between">
				<centerLeft :menu="7"></centerLeft>
				<div class="center-right">
					<div class="coupou-status flex-start flex-center">
						<div :class="status == 1?'active':''" @click="changeStatus(1)">未使用</div>
						<div :class="status == 2?'active':''" @click="changeStatus(2)">已使用</div>
						<div :class="status == 3?'active':''" @click="changeStatus(3)">已过期</div>
					</div>
					
					<div class="coupon-list" v-if="total > 0">
						<div class="flex-between flex-wrap">
							<div class="coupon" v-for="(item, index) in list" :key="item.id">
								<div class="item-top flex-between flex-center">
									<div class="item-top-left">
										<div>{{item.minusAmount}}元</div>
										<div>满减券</div>
									</div>
									<div class="item-top-center">
										<div>{{item.name}}</div>
										<div v-if="status == 1">未使用</div>
										<div v-if="status == 2">已使用</div>
										<div v-if="status == 3">已过期</div>
									</div>
									<div class="item-top-right" @click="toIndex">立即使用</div>
								</div>
								
								<div class="item-bottom">
									有效期: {{item.endTime}}
								</div>
								<div class="item-hr flex-between flex-center">
									<div class="item-left"></div>
									<div class="item-right"></div>
								</div>
							</div>
						</div>
					</div>
					<div class="page" v-if="total > 0">
					    <el-pagination @current-change="getPageList" :current-page="page" :page-size="limit" layout="total, prev, pager, next" :total="total"></el-pagination>
					</div>
					
					
					<noData v-if="list.length == 0 && isLoad == true" msg="暂无优惠券"></noData>
				</div>
			</div>
		</div>
	  </div>
	</div>
</template>

<script>
import centerLeft from '@/components/center-left.vue'
import noData from '@/components/noData.vue'
import {userCouponList} from "@/api/user"
export default {
	name: 'index',
	components:{
		centerLeft,
		noData
	},
	data(){
		return {
			list:[],
			page:1,
			limit:10,
			total:0,
			isLoad:false,
			status:1
		}
	},
	mounted() {
		this.isLoad = false;
		this.getList();
	},
	methods:{
		getList(){
			userCouponList({condition:{status:this.status},page:this.page,size:this.limit}).then(res=>{
				if(res.code == 1000){
					this.list = res.data.list;
					this.total = res.data.total;
					this.isLoad = true;
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		getPageList(e){
			this.isLoad = false;
			this.page = e;
			this.getList();
		},
		toIndex(){
			this.$router.push("/");
		},
		changeStatus(status){
			this.status = status;
			this.isLoad = false;
			this.page = 1;
			this.getList();
		}
	}
}
</script>

<style lang="scss" scoped>
	.coupou-status{
		div{
			padding: 20px 0px 6px;
			font-size: 16px;
			line-height: 20px;
			color: #070B13;
			border-bottom: 3px solid #fff;
			margin-right: 60px;
			cursor: pointer;
		}
		.active{
			color: #E91A12;
			border-bottom: 3px solid #E91A12;
		}
	}
	.coupon-list{
		margin-top: 40px;
		padding: 0px 40px 0px;
		box-sizing: border-box;
		min-height: 710px;
	}
	.center-right{
		min-height: 920px;
		width: 100%;
		padding: 0px 40px;
		box-sizing: border-box;
		border-left: 1px solid rgba(0, 0, 0, 0.1);
	}
	.coupon{
		width: 386px;
		background: rgba(248,248,248, 1);
		position: relative;
		height: 122px;
		margin-bottom: 20px;
		.item-hr{
			position: absolute;
			left: 0px;
			bottom: 22px;
			width: 386px;
			height: 20px;
			.item-left{
				width: 10px;
				height: 20px;
				background: #fff;
				border-radius: 0px 10px 10px 0px;
			}
			.item-right{
				width: 10px;
				height: 20px;
				background: #fff;
				border-radius: 10px 0px 0px 10px;
			}
		}
		.item-bottom{
			width: 100%;
			height: 32px;
			background: rgba(7, 11, 19, 0.1);
			font-size: 14px;
			line-height: 32px;
			text-align: center;
			color: rgba(7, 11, 19, 0.3);
		}
		.item-top{
			padding: 22px 16px 16px 0px;
			.item-top-left{
				color: rgba(233, 26, 18, 1);
				font-weight: 500; 
				width: 104px;
				flex: 0 0 104px;
				text-align: center;
				div{
					&:first-of-type{
						font-size: 24px;
						line-height: 26px;
					}
					&:last-of-type{
						font-size:12px;
						line-height: 26px;
					}
				}
			}
			.item-top-center{
				width: 100%;
				div{
					&:first-of-type{
						font-size: 16px;
						font-weight: 500;
						line-height: 20px;
						color: #070B13;
	
					}
					&:last-of-type{
						width: 48px;
						height: 20px;
						border-radius: 2px;
						background: rgba(255, 29, 20, 0.1);
						margin-top: 8px;
						font-size: 14px;
						line-height: 20px;
						text-align: center;
						color: #E91A12;
					}
				}
			}
			.item-top-right{
				width: 88px;
				height: 28px;
				border-radius: 4px;
				background: #E91A12;
				font-size: 16px;
				font-weight: 500;
				line-height: 28px;
				text-align: center;
				color: #FFFFFF;
				flex: 0 0 88px;
				cursor: pointer;
			}
		}
	}
	@import url("../assets/user.scss");
</style>
